import request from "./request";
// 获取用户权限内的工作室
export const getTeamList = (data) => request("/bireport/getTeam", data, "GET");
// 支出占比
export const getCostPerReport = (data) => request("/bireport/costPerReport", data, "POST_JSON");
// ROI趋势
export const getRoiTrendReport = (data) => request("/bireport/roiTrendReport", data, "POST_JSON");
// 查询新增趋势数据
export const getInstallTrendData = (data) => request("/bireport/installTrend", data, "POST_JSON");
// 查询支出占比数据
export const getCostTrendData = (data) => request("/bireport/costTrend", data, "POST_JSON");
// 查询收入趋势数据
export const getInComeTrendData = (data) => request("/bireport/incomeTrend", data, "POST_JSON");
// 查询内购收入趋势数据
export const getPurchaseIncomeTrendData = (data) => request("/bireport/purchaseIncomeTrend", data, "POST_JSON");
// 内购收入占比
export const getPurchasePerReport = (data) => request("/bireport/purchasePer", data, "POST_JSON");
// 查询arpu趋势数据
export const getArpuTrendData = (data) => request("/bireport/arpuTrend", data, "POST_JSON");
// 表格子页面-新增趋势
export const getInstallTrendTable = (data) => request("/bireport/installTrendReport", data, "POST_JSON");
// 表格子页面-支出趋势
export const getCostTrendTable = (data) => request("/bireport/costTrendReport", data, "POST_JSON");
// 表格子页面-收入趋势
export const getIncomeTrendTable = (data) => request("/bireport/incomeTrendReport", data, "POST_JSON");
// 表格子页面-内购收入趋势
export const getPurchaseIncomeTable = (data) => request("/bireport/purchaseIncomeTable", data, "POST_JSON");
// 表格子页面-arpu收入趋势
export const getArpuTable = (data) => request("/bireport/arpuTable", data, "POST_JSON");
